export const cx = (...xs) => xs.filter(Boolean).join(" ");

export const toNumberOrNull = (v) => {
  if (v === "" || v === null || v === undefined) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

export const parseOptionsLines = (text) => {
  return String(text ?? "")
    .split(/\r?\n/)
    .map((s) => s.trim())
    .filter(Boolean);
};

// User-friendly factors input: one per line as key=value
// Returns:
// - null when empty
// - object when valid
// - undefined when invalid (caller should block submit)
export const parseFactorsLines = (text) => {
  const raw = String(text ?? "").trim();
  if (!raw) return null;

  const obj = {};
  const lines = raw.split(/\r?\n/);
  for (const line of lines) {
    const trimmed = line.trim();
    if (!trimmed) continue;
    const idx = trimmed.indexOf("=");
    if (idx <= 0) return undefined;
    const key = trimmed.slice(0, idx).trim();
    const value = trimmed.slice(idx + 1).trim();
    if (!key) return undefined;
    obj[key] = value;
  }

  return obj;
};

export const formatFactorsLines = (factors) => {
  if (factors === null || factors === undefined || factors === "") return "";
  if (typeof factors === "string") return factors;
  if (typeof factors === "object") {
    try {
      return Object.entries(factors)
        .map(([k, v]) => `${k}=${v}`)
        .join("\n");
    } catch {
      return "";
    }
  }
  return String(factors);
};

export const asString = (v) => (v === null || v === undefined ? "" : String(v));

export const normalizeLower = (v) => String(v ?? "").trim().toLowerCase();

export const FIELD_TYPE_UI_OPTIONS = [
  { value: "text", label: "text" },
  { value: "number", label: "number" },
  { value: "dropdown", label: "dropdown" },
  { value: "radio", label: "radio" },
  { value: "checkbox", label: "checkbox" },
];

export const mapUiFieldTypeToDb = (uiValue) => {
  if (uiValue === "number") return "text";
  return uiValue;
};

export const needsOptionsForDbFieldType = (dbFieldType) => dbFieldType !== "text";

export const computeCoverageWarnings = (ranges) => {
  const warnings = [];
  if (!Array.isArray(ranges) || ranges.length === 0) {
    warnings.push("No reference ranges yet.");
    return warnings;
  }

  const hasGeneral = ranges.some((r) => {
    const gender = normalizeLower(r.gender);
    const preg = normalizeLower(r.pregnancy_status);
    const minAge = r.min_age;
    const maxAge = r.max_age;
    const ageUnbounded =
      (minAge === null || minAge === undefined || minAge === "") &&
      (maxAge === null || maxAge === undefined || maxAge === "");
    return !gender && !preg && ageUnbounded;
  });

  if (!hasGeneral) {
    warnings.push("No general (all genders/ages) range found.");
  }

  return warnings;
};
